import React, { useState, useEffect } from 'react';
import AdminLayout from '@/components/AdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2, Map, Package, Calendar, DollarSign, Users } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState({
    properties: 0,
    inventory: 0,
    reservations: 0,
    revenue: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [propertiesRes, inventoryRes, reservationsRes] = await Promise.all([
        axios.get(`${API_URL}/properties`),
        axios.get(`${API_URL}/inventory`),
        axios.get(`${API_URL}/reservations`)
      ]);

      const revenue = reservationsRes.data.reduce((sum, res) => sum + (res.amount || 0), 0);

      setStats({
        properties: propertiesRes.data.length,
        inventory: inventoryRes.data.length,
        reservations: reservationsRes.data.length,
        revenue
      });
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    }
  };

  const statCards = [
    { title: 'Properties', value: stats.properties, icon: Building2, color: 'text-[#9F1239]' },
    { title: 'Inventory Items', value: stats.inventory, icon: Package, color: 'text-[#0F766E]' },
    { title: 'Reservations', value: stats.reservations, icon: Calendar, color: 'text-[#B45309]' },
    { title: 'Total Revenue', value: `$${stats.revenue.toFixed(2)}`, icon: DollarSign, color: 'text-[#9F1239]' },
  ];

  return (
    <AdminLayout title="Dashboard">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title} className="bg-white border-slate-200 shadow-sm rounded-md" data-testid={`stat-${stat.title.toLowerCase().replace(' ', '-')}`}>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-[#78716C]">{stat.title}</CardTitle>
                <Icon className={`w-5 h-5 ${stat.color}`} strokeWidth={1.5} />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-serif font-bold text-[#1C1917]">{stat.value}</div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="mt-8 bg-white border-slate-200 shadow-sm rounded-md">
        <CardHeader>
          <CardTitle className="text-xl font-serif">Quick Actions</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-[#78716C]">
            Use the navigation menu to manage properties, inventory, reservations, pricing, and more.
          </p>
        </CardContent>
      </Card>
    </AdminLayout>
  );
}
